import { Field } from 'formik';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from './base-url-params-filter';
import { CashflowPicker } from 'shared/ui/formik-fields/cashflow-picker';

export const CashflowUrlParamsFilter = ({ queryParamName, label = 'Статья ДДС', size = 'medium' }: BaseUrlParamsFilterProps) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field
        fullWidth
        name={queryParamName}
        label={label}
        size={size}
        component={CashflowPicker}
      />
    </BaseUrlParamsFilter>
  );
};
